import React, { Context, createContext, Dispatch, useContext } from 'react';
import { useImmerReducer } from 'use-immer';

import {
  DimensionClassAction,
  DimensionClassState,
  DimensionClassReducer,
  DimensionClassStateType,
} from './useDimensionClassReducer';

interface Props {
  children?: React.ReactNode;
}

const initialDimensionClassState = {
  currentState: DimensionClassStateType.LOADING,
  pageNumber: 1,
};

const DimensionClassContext = createContext<unknown>({});

export const DimensionClassProvider: React.FC<Props> = ({ children }) => {
  const [state, dispatch] = useImmerReducer(
    DimensionClassReducer,
    initialDimensionClassState,
  );
  return (
    <DimensionClassContext.Provider value={[state, dispatch]}>
      {children}
    </DimensionClassContext.Provider>
  );
};

export const useDimensionClass = () =>
  useContext<[DimensionClassState, React.Dispatch<DimensionClassAction>]>(
    DimensionClassContext as Context<
      [DimensionClassState, Dispatch<DimensionClassAction>]
    >,
  );
